// @storybook-skip: internal section of LessonsHomeScreen; covered by its screen story
import { useTranslation } from "react-i18next";
import { ScrollView } from "react-native";
import { Text } from "react-native-paper";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import { SuggestedLessonCard } from "./SuggestedLessonCard";
import type { SuggestedLesson } from "./types";

type Props = {
	title?: string;
	lessons: SuggestedLesson[];
	onLessonPress: (lesson: SuggestedLesson) => void;
};

export const SuggestedForYouSection = ({
	title,
	lessons,
	onLessonPress,
}: Props) => {
	const { t } = useTranslation();
	const { isMobile } = useDevice();
	const cardWidth = isMobile ? 264 : 300;

	if (!lessons.length) {
		return null;
	}

	return (
		<Box gap={16}>
			<Box paddingHorizontal={16}>
				<Text variant="titleLarge">
					{title ?? t("lessons.home.suggested.title")}
				</Text>
			</Box>
			<ScrollView
				horizontal
				showsHorizontalScrollIndicator={false}
				contentContainerStyle={{ paddingHorizontal: 16 }}
			>
				{lessons.map((lesson, index) => (
					<Box
						key={lesson.id}
						marginRight={index === lessons.length - 1 ? 0 : 16}
						paddingBottom={4}
					>
						<SuggestedLessonCard
							cardWidth={cardWidth}
							lesson={lesson}
							onPress={onLessonPress}
						/>
					</Box>
				))}
			</ScrollView>
		</Box>
	);
};
